<div class="small-pagination">
    <div class="page-size">
        <span>Mostrando</span>
        <select name="resultSize" (change)="emitSize($event)">
            <ng-container *ngFor="let opt of options">
                <option [value]="opt" [selected]="opt == size">{{opt}}</option>
            </ng-container>
        </select>
        <span>resultados</span>
    </div>
    <div class="arrows" *ngIf="isPaginado">
        <button class="fas fa-chevron-left" (click)="currentPage = currentPage - 1; emitPage()" [disabled]="currentPage == 0"></button>
        <button class="fas fa-chevron-right" (click)="currentPage = currentPage + 1; emitPage()" [disabled]="disableNext"></button>
    </div>
</div>